export default {"src":"/_next/static/media/mobile_consultunt_img_01.b4a59280.svg","height":140,"width":300};